/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Output_StyleInputs */



/**
* | output |
* | --- |
* | "Output & Style" |
*
* @param {Ad_Section_Output_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_output_style = /** @type {((inputs?: Ad_Section_Output_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Output_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sortie et style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabe & Stil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Output e stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вывод и стиль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Salida y estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出与风格")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力とスタイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट और शैली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Saída e estilo")
	return /** @type {LocalizedString} */ ("Output & Style")
});